var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users-and-groups-wrapper card"},[_c('page-header',{attrs:{"title":"Add User","breadcrumbText":"Dashboard >> Settings >> Users and Groups >> Add User"}}),_c('new-user-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }